"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TranslationWidth;
(function (TranslationWidth) {
    TranslationWidth["SHORT"] = "short";
    TranslationWidth["LONG"] = "long";
})(TranslationWidth = exports.TranslationWidth || (exports.TranslationWidth = {}));
//# sourceMappingURL=type.js.map